import { useState, useEffect } from 'react';
import { Box, FormControl, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';

const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);

const TmdayFilterOptions = ({ varState, setVarState }) => {
    const [selectedDays, setSelectedDays] = useState([]);

    useEffect(() => {
        if (varState?.a?.d) {
            setSelectedDays(mergeData(varState.a.d));
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setVarState({
            ...varState,
            a: {
                ...varState?.a,
                ...formatDays(selectedDays)
            }
        });
        // eslint-disable-next-line
    }, [selectedDays]);

    const mergeData = (value) => {
        let result = [];
        let ranges = value?.split(',');
        ranges?.forEach(range => {
            if (range.includes('-')) {
                let [start, end] = range.split('-').map(Number);
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
            } else {
                result.push(Number(range));
            }
        });
        return result;
    };

    const formatDays = (days) => {
        if (days.length === 31) return { d: '1-31' };

        let sorted = [...days].sort((a, b) => a - b);
        let result = [];
        let start = sorted[0];

        for (let i = 1; i <= sorted.length; i++) {
            if (sorted[i] !== sorted[i - 1] + 1) {
                const end = sorted[i - 1];
                result.push(start === end ? `${start}` : `${start}-${end}`);
                start = sorted[i];
            }
        }

        return { d: result.join(',') };
    };

    const handleDayChange = (day) => {
        setSelectedDays(prev =>
            prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
        );
    };

    return (
        <Box>
            <Box width={'100%'} mt={2}>
                <FormControl component="fieldset">
                    <FormGroup style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px' }}>
                        {monthDays.map((day) => (
                            <FormControlLabel
                                key={day}
                                control={
                                    <Checkbox
                                        checked={selectedDays.includes(day)}
                                        onChange={() => handleDayChange(day)}
                                        color="primary"
                                    />
                                }
                                label={day.toString()}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </Box>
        </Box>
    );
};

export default TmdayFilterOptions;
